import { Cable, CableReel, ConstructionStatus, DataType, MetadataColumn, ProcessLength } from '@bechtel/sr-types';
import { find, isEmpty, isNil, map, pick } from 'lodash';
import { formatValues } from '~/utilities';
import { CableFeedbackFormikState } from './form/types';

export const cableFeedbackInitialValues: CableFeedbackFormikState = {
  tag: '',
  constructionStatus: '',
  installedBy: '',
  installedTime: '',
  inspectedBy: '',
  inspectedTime: '',
  actualLength: 0,
  meggerDevice: '',
  isRecalcReqd: false,
  processLength: ProcessLength.CUT,
  id: '',
  cableReels: [],
  tagInvalid: false,
};

export const getFormikData = (
  data: Cable | CableReel,
  keys: string[],
  metadataColumn: MetadataColumn[],
  isCableReels?: boolean
): Partial<CableFeedbackFormikState> => {
  if (!data) return {};

  const formData = { ...data };

  // Transform null to an empty string for all the properties of the object
  const transformedData = Object.fromEntries(
    Object.entries(formData).map(([key, value]) => [key, isNil(value) ? '' : value])
  );

  const formikState: Partial<CableFeedbackFormikState> = {
    ...pick(formatValues(formData, metadataColumn), keys),
    tagInvalid: false,
  };

  if (isCableReels) {
    const cableReelKeys: string[] = ['reel.tag', 'assignedLength', 'cutLength', 'reel.id', 'reel.badLength'];
    const cableReelData =
      map(transformedData.cableReel, (item) => pick(formatValues(item, metadataColumn), cableReelKeys)) || [];

    return {
      ...formikState,
      constructionStatus: !formikState.constructionStatus
        ? ConstructionStatus.CABLE_CUT
        : formikState.constructionStatus,
      cableReels: isEmpty(cableReelData) ? [{ cutLength: 0, reel: { tag: '', id: '' } }] : cableReelData,
      tagInvalid: false,
    };
  }

  return formikState;
};

export const sanitizedData = (values, metadataColumns: MetadataColumn[] | undefined) => {
  return Object.keys(values).reduce((acc, key) => {
    const matchingColumn = find(metadataColumns, { memberName: key });
    const value = matchingColumn?.dataType === DataType.NUMBER ? parseFloat(values[key]) : values[key];
    acc[key] = value === '' ? null : value;
    return acc;
  }, {});
};

export const getCutLength = (index: number, decimalUpto: number, isMarked) => {
  const stopMark = parseFloat(isMarked[`stopMark-${index}`]);
  const startMark = parseFloat(isMarked[`startMark-${index}`]);

  if (!isNaN(stopMark) && !isNaN(startMark)) {
    return { key: `cableReels[${index}].cutLength`, value: Math.abs(startMark - stopMark)?.toFixed(decimalUpto) };
  }
};
